import { Badge, BadgeProps } from '@chakra-ui/react';
import {
  BATCH_STATUS_COLORS,
  BATCH_STATUS_LABELS,
  BatchStatus,
  RECORD_STATUS_COLORS,
  RECORD_STATUS_LABELS,
  RecordStatus,
} from '../types/nfse.types';

interface BatchStatusBadgeProps extends BadgeProps {
  status: BatchStatus;
}

interface RecordStatusBadgeProps extends BadgeProps {
  status: RecordStatus;
}

export const BatchStatusBadge: React.FC<BatchStatusBadgeProps> = ({
  status,
  ...props
}) => {
  return (
    <Badge colorScheme={BATCH_STATUS_COLORS[status]} {...props}>
      {BATCH_STATUS_LABELS[status]}
    </Badge>
  );
};

export const RecordStatusBadge: React.FC<RecordStatusBadgeProps> = ({
  status,
  ...props
}) => {
  return (
    <Badge colorScheme={RECORD_STATUS_COLORS[status]} {...props}>
      {RECORD_STATUS_LABELS[status]}
    </Badge>
  );
};

const StatusBadge = RecordStatusBadge;
export default StatusBadge;
